module.exports = __webpack_public_path__ + "static/media/mute-white.d8f84eb5.svg";